<template>
  <ActionForm
    class="change-auth0-email"
    title="Change Auth0 Email Address"
    description="Use this component if you wish to change a user's login email address"
    submit-label="Change Email"
    icon="mdi-email-edit-outline"
    :loading="loading"
    :status="status"
    :message="resp"
    success-message="User updated successfully"
    @submit="callapi"
  >
    <v-col cols="12" md="6">
      <v-text-field
        v-model="oldUsername"
        :rules="emailRules"
        label="Current Username"
        prepend-inner-icon="mdi-at"
      ></v-text-field>
    </v-col>

    <v-col cols="12" md="6">
      <v-text-field
        v-model="newUsername"
        :rules="newUsernameRules"
        label="New Username"
        prepend-inner-icon="mdi-at"
      ></v-text-field>
    </v-col>
  </ActionForm>
</template>

<script>
import api, { apiErrorMessage } from "../services/api";
import { emailRules, sameEmail, normalizeEmail } from "../utils/validators";
import ActionForm from "./ActionForm.vue";

export default {
  name: "ChangeAuth0Email",
  components: { ActionForm },
  data() {
    return {
      oldUsername: null,
      newUsername: null,
      resp: null,
      status: null,
      loading: false,
      emailRules,
      // Only the "new" field carries the difference check, so the error is
      // reported once instead of on both inputs. The comparison runs on
      // normalized values because that is what actually gets sent — otherwise
      // "John@x.com" vs "john@x.com " passes and we POST two identical
      // addresses.
      newUsernameRules: [
        ...emailRules,
        () =>
          !sameEmail(this.oldUsername, this.newUsername) ||
          "Desired username is the same as the old username",
      ],
    };
  },
  methods: {
    // ActionForm validates before emitting, so this only runs on a valid form.
    async callapi() {
      this.status = null;
      this.resp = null;
      this.loading = true;
      const oldUsername = encodeURIComponent(normalizeEmail(this.oldUsername));
      const newUsername = encodeURIComponent(normalizeEmail(this.newUsername));
      try {
        const response = await api.post(
          `/auth0changeemail/${oldUsername}/${newUsername}`
        );
        this.status = response.status;
        this.resp = response.data;
      } catch (error) {
        this.status = error.response?.status ?? null;
        this.resp = apiErrorMessage(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
